const state = {
  all: []
}

const mutations = {
  addNotification (state, notification) {
    state.all.push(notification)
  },
  resetNotifications (state) {
    state.all = []
  }
}

const getters = {
  all: state => {
    return state.all
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/notifications.js